import { createFileRoute } from "@tanstack/react-router";
import { canonicalLink, pathFromMatch, routeMeta } from "@/lib/seo";
import { cityHeadScripts } from "@/lib/cityJsonLd";
import { CityHomePage } from "@/components/CityHomePage";
import hero from "@/assets/original/hero-shade.jpg";

export const Route = createFileRoute("/eagle-pass")({
  head: (ctx) => ({
    links: [canonicalLink(pathFromMatch(ctx))],
    meta: routeMeta(ctx, {
      title: "Custom Awnings, Covers & Shade in Eagle Pass, TX | Texas Made Shade",
      description: "Custom welded awnings, patio & pergola covers, sail shades and aluminum fabrication for Eagle Pass & Maverick County. Free quotes — +1 (830) 390-9588.",
      keywords: "pergola covers Eagle Pass, pergola covers Texas, custom pergola covers Eagle Pass, aluminum pergola covers Eagle Pass",
      image: hero,
      socialTitle: "Custom Awnings & Shade — Eagle Pass, TX",
      socialDescription: "Welded aluminum + Sunbrella canvas. Custom shade, covers and fabrication serving Eagle Pass and Maverick County.",
    }),
    scripts: cityHeadScripts("Eagle Pass", "Maverick County"),
  }),
  component: () => <CityHomePage city="Eagle Pass" region="Maverick County" />,
});
